import { render } from "./BotaoCadastroAcoes.vue?vue&type=template&id=bc506d86"
import script from "./BotaoCadastroAcoes.vue?vue&type=script&lang=js"
export * from "./BotaoCadastroAcoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__